// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"9c65fa2a","142":"f615a069","185":"f615a069","291":"2d4eef23","412":"ebadabba","925":"f615a069"}[chunkId] + ".chunk.css";
};